import { ShieldCheck, Lightbulb, Handshake, Truck } from 'lucide-react';
import { values } from '../mock';

const iconMap = { ShieldCheck, Lightbulb, Handshake, Truck };

export default function WhyChooseUs() {
  return (
    <section className="bg-[#0b0b0d] text-white py-24 lg:py-32 relative overflow-hidden noise">
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className="absolute -left-20 top-1/2 h-96 w-96 rounded-full bg-amber-500/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-4">
              — Why Choose Us
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold leading-[1.05]">
              Every rod is a promise —
              <span className="text-amber-400"> and we keep it.</span>
            </h2>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              Our unique value propositions underscore four decades of industry leadership,
              consistent quality, and relentless customer focus.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {values.map((v, i) => {
              const Icon = iconMap[v.icon] || ShieldCheck;
              return (
                <div
                  key={v.title}
                  className="card-lift group relative rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur hover:border-amber-500/50"
                >
                  <div className="absolute top-6 right-6 font-mono text-[10px] text-white/30">
                    0{i + 1}
                  </div>
                  <div className="h-11 w-11 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mb-5 group-hover:bg-amber-500 group-hover:border-amber-500 transition-colors">
                    <Icon className="h-5 w-5 text-amber-400 group-hover:text-[#0b0b0d] transition-colors" />
                  </div>
                  <h3 className="font-display text-xl font-semibold mb-2">{v.title}</h3>
                  <p className="text-sm text-white/60 leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
